// libraries
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { notification, Table, Tag, Tooltip } from 'antd';
import moment from 'moment';

// services
import * as PostService from '../../../../../services/bb-api/post';
import { txt } from '../../../../../locales/i18n';

// components
import { SharedTable } from '../../../../shared/table';

export function ConversationTab(props: any): JSX.Element {
	const [loading, setLoading] = useState<boolean>(true);
	const [conversations, setConversations] = useState<Record<string, any>[]>([]);

	const { id } = useParams<any>();
	const history = useHistory();

	useEffect(() => {
		async function getConversations(): Promise<void> {
			setLoading(true);

			try {
				const conversations: Record<string, any>[] = await PostService.getConversations(id);
				setConversations(conversations);
			} catch (error) {
				const message: string = (error as Error).name;
				const description: string = (error as Error).message;
				notification.error({ message, description });
			}

			setLoading(false);
		}

		getConversations();
	}, [id]);

	function formatDate(date: Date): string {
		const format: string = 'ddd DD/MM-YY HH:mm';
		const dateString: string = moment(date).format(format);
		return dateString;
	}

	function renderUsers(users: Record<string, any>[]): JSX.Element[] {
		return users.map((user: Record<string, any>) => {
			let color: string = 'default';
			if (user.id === props.userId) color = 'blue';

			return (
				<Tooltip title={txt('global.open')} key={user.id}>
					<Tag onClick={(event) => navigateToUser(event, user.id)} color={color}>
						{user.username}
					</Tag>
				</Tooltip>
			);
		});
	}

	function navigateToUser(event: any, userId: number): void {
		event.stopPropagation();
		history.push(`/users/${userId}`);
	}

	function handleRowEvents(conversation: Record<string, any>) {
		const userId: number = conversation.users[0].id;

		return {
			onClick: () => history.push(`/users/${userId}/conversations/${conversation.id}`),
		};
	}

	return (
		<SharedTable
			loading={loading}
			dataSource={conversations}
			onRow={handleRowEvents}
			rowKey="id"
		>
			<Table.Column
				dataIndex="created"
				title={txt('global.created')}
				render={formatDate}
				width="24ch"
			/>
			<Table.Column dataIndex="messageCount" title={txt('global.messages')} width="12ch" />
			<Table.Column dataIndex="id" title="ID" width="18ch" />
			<Table.Column
				dataIndex="users"
				title={txt('menu.users')}
				render={renderUsers}
				ellipsis
			/>
			<Table.Column dataIndex="lastMessage" title={txt('global.last message')} ellipsis />
		</SharedTable>
	);
}
